import { configureStore } from '@reduxjs/toolkit'
import roomCostsReducer from "./reducers/roomCostsSlice"

export const store = configureStore({
    reducer: {
        accommodation: roomCostsReducer
    }
})